/** Tenant glossary helpers — entity labels (Lead → Prospecto, etc.) */
import { useEffect, useState } from 'react';
import api from './api';

const DEFAULTS = {
  lead: 'Lead',
  leads: 'Leads',
  deal: 'Deal',
  deals: 'Deals',
  company: 'Empresa',
  companies: 'Empresas',
  pipeline: 'Pipeline',
  stage: 'Etapa',
  task: 'Tarea',
  tasks: 'Tareas',
  campaign: 'Campaña',
  campaigns: 'Campañas',
};

let _cache = null;
let _promise = null;

export async function loadGlossary(force = false) {
  if (_cache && !force) return _cache;
  if (_promise && !force) return _promise;
  _promise = api.get('/admin/config')
    .then((r) => {
      _cache = { ...(r.data.glossary || DEFAULTS) };
      return _cache;
    })
    .catch(() => {
      _cache = { ...DEFAULTS };
      return _cache;
    })
    .finally(() => { _promise = null; });
  return _promise;
}

export function g(key, glossary) {
  const map = glossary || _cache || DEFAULTS;
  return map[key] || DEFAULTS[key] || key;
}

export function useGlossary() {
  const [glossary, setGlossary] = useState(_cache || DEFAULTS);
  useEffect(() => {
    loadGlossary().then(setGlossary);
  }, []);
  return {
    glossary,
    t: (key) => g(key, glossary),
    reload: () => loadGlossary(true).then(setGlossary),
  };
}
